import { DueDiligenceDocumentPage } from './DueDiligenceDocument';
import { createLoader } from './loader';
import { createHandle } from './handle';

export default {
  Component: DueDiligenceDocumentPage,
  createHandle,
  createLoader
};
